import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class TranslationService {
    defaultLang = 'en';

    /** Resolves once the base translations of the saved language are loaded. */
    readonly ready: Promise<void> = Promise.resolve();

    constructor(private translateService: TranslateService, @Inject(PLATFORM_ID) private platformId: object) {
        if (isPlatformBrowser(this.platformId)) {
            const savedLang = localStorage.getItem('lng');
            if (savedLang) {
                this.defaultLang = savedLang;
            }
            this.translateService.setDefaultLang(this.defaultLang);
            this.ready = firstValueFrom(this.translateService.use(this.defaultLang))
                .then(() => undefined)
                .catch(error => console.warn('[Translation] Failed to load base translations:', error));
        }
    }

    changeLang(lang: string) {
        this.translateService.use(lang);
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('lng', lang);
        }
        /*this.translateService.reloadLang(lang);*/
    }
}
